var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.97 4.6899V6.2266C13.97 7.2299 13.335 7.8649 12.3317 7.8649H10.16V3.42625C10.16 2.7214 10.7379 2.1499 11.4427 2.1499C12.1349 2.15625 12.7699 2.43565 13.2271 2.89285C13.6843 3.3564 13.97 3.9914 13.97 4.6899Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1601 8.8174V3.4199C10.1601 2.7214 10.7316 2.1499 11.4301 2.1499H4.44514H3.81014C1.90514 2.1499 1.27014 3.28655 1.27014 4.6899V5.3249V14.2149C1.27014 14.742 1.86703 15.0404 2.28613 14.7229L3.37199 13.9101C3.62599 13.7196 3.98159 13.745 4.21019 13.9736L5.26428 15.0341C5.51193 15.2817 5.91836 15.2817 6.16601 15.0341L6.6994 14.5007",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5617 11.4669L10.7217 11.7925C10.8016 11.9524 11.0015 12.1009 11.1786 12.1352L11.3956 12.1695C12.0468 12.278 12.201 12.7578 11.7326 13.2318L11.5327 13.4317C11.4013 13.5688 11.3271 13.8315 11.3671 14.0143L11.3956 14.1343C11.5727 14.9225 11.1557 15.2252 10.4703 14.8139L10.3218 14.7283C10.1448 14.6255 9.8592 14.6255 9.68214 14.7283L9.53363 14.8139C8.84252 15.2309 8.42557 14.9225 8.60834 14.1343L8.63689 14.0143C8.67687 13.8315 8.60264 13.5688 8.47127 13.4317L8.27136 13.2318C7.803 12.7578 7.95721 12.278 8.60834 12.1695L8.82539 12.1352C8.99674 12.1066 9.20235 11.9524 9.28231 11.7925L9.44224 11.4669C9.75067 10.8444 10.2533 10.8444 10.5617 11.4669Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81006 6.59497H7.62006",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28638 9.13501H7.14388",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.e7daab0c.svg";
export { ForwardRef as ReactComponent };